/**
 *
 * BigSelector
 *
 */
import * as React from 'react';
import Img from 'components/Img';
import { FiInfo } from 'react-icons/fi';
import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { useEffect } from 'react';

interface Props {
  imgSrc: string;
  title: string;
  subtitle?: string;
  tooltips?: boolean;
  handleClick?: any;
  handleDoubleClick?: any;
  handleHover?: any;
  onLeave?: any;
  selected?: boolean;
  rectangle?: boolean; // Square icon or rectangle
  className?: string;
  enable?: boolean;
  disableMessage?: string;
  infoMessage?: string;
  smallTitle?: boolean;
}

function BigOptionButton({
  className,
  handleClick,
  handleDoubleClick,
  handleHover,
  imgSrc,
  onLeave,
  rectangle,
  selected,
  subtitle,
  title,
  tooltips,
  enable = true,
  disableMessage,
  infoMessage,
  smallTitle = true,
}: Props) {
  return (
    <>
      <StyledBigOptionButton
        className={`flex flex-col mx-0 w-26 ${!enable &&
          'opacity-25 cursor-not-allowed'} ${className}`}
        onClick={enable ? handleClick : undefined}
        onMouseOver={enable ? handleHover : undefined}
        onMouseLeave={enable ? onLeave : undefined}
        selected={selected}
        onDoubleClick={handleDoubleClick}
        data-tip={!enable ? disableMessage : undefined}
        data-for="disableInfoMsg"
      >
        <StyledBigOptionButtonImg
          src={imgSrc}
          alt={title}
          className="self-center"
          selected={selected}
          rectangle={rectangle}
        />
        {!tooltips && (
          <div className="self-center w-20 md:w-24 text-xs flex items-center justify-center">
            <div className={`${smallTitle ? 'text-xs' : 'text-base'}`}>
              {title}
            </div>
            {infoMessage && enable && (
              <div className="ml-2" data-tip={infoMessage} data-for="infoCP">
                <FiInfo className="h-4 w-4" />
              </div>
            )}
          </div>
        )}
        {subtitle && (
          <div className="self-center w-20 md:w-24 text-xs">{subtitle}</div>
        )}
      </StyledBigOptionButton>
    </>
  );
}

export default BigOptionButton;

const StyledBigOptionButton = styled.button<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  color: ${p => p.theme.gray800};

  &:hover {
    background-color: ${p => p.theme.hover};
  }

  ${p =>
    p.selected &&
    css`
      background-color: ${p => p.theme.main} !important;
      color: white;
    `};
`;

const StyledBigOptionButtonImg = styled(Img)<{
  selected?: boolean;
  rectangle?: boolean;
}>`
  //border: ${props => (props.selected ? 'solid 2px #8795a1' : '')};
  height: 4rem;
  width: ${props => (props.rectangle ? '6rem' : '4rem')};
  margin: 0 0.8rem;
`;
